import { Modal } from "react-bootstrap";
import React from "react";

const EventModal = ({ setShow, show, info }) => {
  const {
    event_subtitle,
    top_banner,
    summery,
    
    reg_link, } = info.node

  return (
    <Modal
      show={show}
      backdrop="static"
      centered
      onHide={() => setShow(false)}
      className="project-modal modal-bgstyle"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="border-0" closeButton>
        <Modal.Title id="example-custom-modal-styling-title"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="  ">
          <div className="card mb-3 border-0 m-2" >
            <div className="row g-0 d-flex justify-content-center ">
              <div className="col-md-12 tm-modal-media d-flex justify-content-center  pt-1">
                <img
                  src={top_banner?.url}
                  className="img-fluid rounded-start "
                  alt="..."
                ></img>
              </div>
              <div className="col-md-12 ">
                <div className="card-body pt-0">
                  {summery?.map((para, index) => <p className="card-text">{para?.para }</p>)}
 
                  <a
                    target="_blank"
                    className="text-decoration-none"
                    href={reg_link && reg_link}  >
                    <button type="button" className="  primary-btn">
                    Watch Now
                    </button>
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal >
  );
};

export default EventModal;
